import { queryOptions, useQuery } from '@tanstack/react-query'

import { api } from '@/lib/api-client'
import { QueryConfig } from '@/lib/react-query'

type Plan = {
    id: string
    name: string
    description: string | null
    pricePerMonth: number
    maxFFLs: number
    maxDocuments: number
    isCustom: boolean
}

export const getPlans = (): Promise<Plan[]> => {
    return api.get('/v2/plans')
}

export const getPlansQueryOptions = () => {
    return queryOptions({
        queryKey: ['plans'],
        queryFn: () => getPlans(),
    })
}

type UsePlansOptions = {
    queryConfig?: QueryConfig<typeof getPlans>
}

export const usePlans = ({ queryConfig }: UsePlansOptions = {}) => {
    return useQuery({
        ...getPlansQueryOptions(),
        ...queryConfig,
    })
}


